import { useCallback, useState, type ReactElement } from 'react'
import * as S from './faq.styled'
import { FaqCard } from '../faq-card/faq-card'
import cloud from './assets/cloud.svg'
import card from './assets/card.svg'
import { faq } from './faq-data'
import FaqAccordion from '../accordion/faq-accordion'

export function Faq (): ReactElement {
  const [activeAccordion, setActiveAccordion] = useState<number>()

  const handleOnOpen = useCallback((newIndex?: number): void => {
    setActiveAccordion(newIndex)
  }, [])

  return <S.Container>
    <S.Content>
      <S.TextContent>
        <div className="header">
          <h6>TIRE SUAS DÚVIDAS</h6>
          <h1>Regras do sorteio e dúvidas frequentes</h1>
          <p>Reunimos pra você as perguntas que mais chegam por aqui.</p>
        </div>
        <S.Subjects className="subjects">
        <FaqCard icon={cloud} text="Confira nossa Central de Ajuda" title="Dúvidas?" href="https://www.cartaodetodos.com.br/ajuda/" />
        <FaqCard icon={card} text="Cadastre-se e aproveite" title="Peça o seu cartão" href="https://idpv.cartaodetodos.com.br/dados-pessoais/?from_lead=1&idpv=593fe813-3579-442f-b0c2-17a883e92e24" />
          <S.SAC>
            <p><strong>Horário atendimento SAC</strong></p>
            <p>
              Segunda-sexta: 08hs às 19hs
              <br />
              Sábado: 08hs às 13hs
            </p>
          </S.SAC>
        </S.Subjects>
      </S.TextContent>
      <S.Accordions>
        {faq.map(({ text, title }, index) => <FaqAccordion
          index={index}
          isOpen={activeAccordion === index}
          onOpen={handleOnOpen}
          title={title}
        >
          <div dangerouslySetInnerHTML={{ __html: text }} />
        </FaqAccordion>)}
      </S.Accordions>
      <S.Subjects className="subjects">
        <FaqCard icon={cloud} text="Confira nossa Central de Ajuda" title="Dúvidas?" href="https://www.cartaodetodos.com.br/ajuda/" />
        <FaqCard icon={card} text="Cadastre-se e aproveite" title="Peça o seu cartão" href="https://idpv.cartaodetodos.com.br/dados-pessoais/?from_lead=1&idpv=593fe813-3579-442f-b0c2-17a883e92e24" />
        <S.SAC>
            <p><strong>Horário atendimento SAC</strong></p>
            <p>
              Segunda-sexta: 08hs às 19hs
              <br />
              Sábado: 08hs às 13hs
            </p>
          </S.SAC>
      </S.Subjects>
    </S.Content>
  </S.Container>
}
